import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpCharges
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * List the fees of network point exit and entry.
     *
     * @param {Number|undefined} tsoNumber Used to only display charges of the one tso0 or tso1.
     *  If not specified, it will display both.
     * @param {Object} charges
     * @param {Object} networkPoint `NetworkPointDto`
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpCharges', pkpCharges);

    function pkpCharges(platformSettingsService, auctionsOverviewService) {
        return {
            restrict: 'E',
            scope: {
                tsoNumber: '@',
                charges: '=',
                networkPoint: '='
            },
            template: require('app/_directives/pkp-charges.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DIRECTION = platformSettingsService.DIRECTION;
            scope.hasFeesAttached = auctionsOverviewService.hasFeesAttached(
                scope.charges,
                scope.tsoNumber
            );
        }
    }
})();
